// schema.js
import * as Yup from "yup";
export const ExpenseFormValidationSchema = Yup.object().shape({
  expenditureType: Yup.string().required("Expenditure type is required"),
  expenditureCategory: Yup.string().required("Category is required"),
  frequency: Yup.string().required("Frequency is required"),
  description: Yup.string().required("Description is required"),
  startDate: Yup.string(),
  endDate: Yup.string(),
  amount: Yup.number().required("Amount is required"),
});
